import React, { useState } from 'react'
import cn from 'classnames'
import { Field, useForm } from 'react-final-form'
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from 'react-places-autocomplete'
import { GoogleApiWrapper, Map, Marker } from 'google-maps-react'
import _ from 'lodash'
import { geolocated } from 'react-geolocated'
import Button from 'components/Button'
import css from './styles.module.scss'

const LocationInput = ({
  label,
  hint,
  hideError,
  autoComplete = false,
  addressName,
  latName,
  lngName,
  cityName,
  postalCodeName,
  google,
  coords,
  ...restProps
}) => {
  const form = useForm()
  const values = form.getState().values
  const [search, setSearch] = useState(values[addressName] || '')
  const initialCenter =
    values[latName] && values[lngName]
      ? { lat: values[latName], lng: values[lngName] }
      : {
          lat: 51.510357,
          lng: -0.116773,
        }
  const [center, setCenter] = useState(initialCenter)
  if (values['forceUpdate']) {
    form.mutators.setFieldValue('forceUpdate', false)
    try {
      geocodeByAddress(values[addressName]).then(results => {
        applyGoogleResult(results[0])
      })
    } catch (err) {
      console.error(err)
    }
  }
  const clearInput = () => {
    form.mutators.setFieldValue(addressName, '')
    form.mutators.setFieldValue(latName, '')
    form.mutators.setFieldValue(lngName, '')
    form.mutators.setFieldValue(cityName, '')
    form.mutators.setFieldValue(postalCodeName, '')
  }

  const applyGoogleResult = async (result, latLng) => {
    console.log(result.address_components);
    const latLngHere = latLng || (await getLatLng(result))
    const addressComponentWithCityname =
      _.find(result.address_components, addressComponent => {
        return _.includes(addressComponent.types, 'postal_town')
      }) ||
      _.find(result.address_components, addressComponent => {
        return _.includes(addressComponent.types, 'locality')
      }) ||
      _.find(result.address_components, addressComponent => {
        return _.includes(addressComponent.types, 'administrative_area_level_2')
      })
    const addressComponentWithPostalCode = _.find(
      result.address_components,
      addressComponent => {
        return _.includes(addressComponent.types, 'postal_code')
      }
    )
    console.log(addressComponentWithCityname);
    if (!addressComponentWithCityname) return
    const city = addressComponentWithCityname.long_name
    const lat = latLngHere.lat
    const lng = latLngHere.lng
    const address = result.formatted_address
    form.mutators.setFieldValue(addressName, address)
    form.mutators.setFieldValue(latName, lat)
    form.mutators.setFieldValue(lngName, lng)
    form.mutators.setFieldValue(cityName, city)
    form.mutators.setFieldValue(
      postalCodeName,
      addressComponentWithPostalCode
        ? addressComponentWithPostalCode.long_name
        : ''
    )
    setCenter({ lat, lng })
    console.log(888);
    setSearch(address)
  }

  const applyCoords = async (lat, lng) => {
    const geocoder = new google.maps.Geocoder()
    geocoder.geocode({ location: { lat, lng } }, function(results, status) {
      if (status === 'OK') {
        if (results[0]) {
          applyGoogleResult(results[0], { lat, lng })
        } else {
          window.alert('No results found')
        }
      } else {
        window.alert('Geocoder failed due to: ' + status)
      }
    })
  }

  return (
    <div className={cn('field', css.locationInput)}>
      <Field {...restProps} name={addressName}>
        {({ input, meta, placeholder, ...restFieldProps }) => {
          const isInvalid =
            (meta.error || meta.submitError) && meta.submitFailed
          return (
            <div className="field">
              {label && (
                <label
                  className="label"
                  htmlFor={restFieldProps.id || input.name}
                >
                  {label}
                </label>
              )}
              <div className="control">
                <PlacesAutocomplete
                  value={search}
                  onChange={value => {
                    if (!value) clearInput()
                    setSearch(value)
                  }}
                  debounce={500}
                  onSelect={async search => {
                    try {
                      const results = await geocodeByAddress(search)
                      applyGoogleResult(results[0])
                    } catch (err) {
                      console.error(err)
                    }
                  }}
                >
                  {({
                    getInputProps,
                    suggestions,
                    getSuggestionItemProps,
                    loading,
                  }) => {
                    const { onBlur, ...inputProps } = getInputProps({
                      placeholder: 'Search address',
                      className: 'input',
                    })
                    return (
                      <div className={css.inputWithDropdown}>
                        {!!coords && (
                          <div className="field is-grouped is-grouped-multiline">
                            <div className="control">
                              <Button
                                outline
                                href="#null"
                                onClick={e => {
                                  e.preventDefault()
                                  applyCoords(coords.latitude, coords.longitude)
                                }}
                              >
                                Set my current location
                              </Button>
                            </div>
                          </div>
                        )}
                        <input
                          {...inputProps}
                          onBlur={() => {
                            onBlur()
                            setSearch(values[addressName] || '')
                          }}
                          className={cn({
                            input: true,
                            'is-danger': isInvalid,
                          })}
                          autoComplete="off"
                        />
                        {(!!suggestions.length || loading) && (
                          <div className={css.dropdown}>
                            {loading && <div className="loader" />}
                            {suggestions.map(suggestion => {
                              const className = suggestion.active
                                ? css.suggestionItemActive
                                : css.suggestionItem
                              return (
                                <div
                                  {...getSuggestionItemProps(suggestion, {
                                    className,
                                  })}
                                >
                                  <span>{suggestion.description}</span>
                                </div>
                              )
                            })}
                          </div>
                        )}
                      </div>
                    )
                  }}
                </PlacesAutocomplete>
                {isInvalid && !hideError && (
                  <p
                    className={cn({
                      help: true,
                      'is-danger': isInvalid,
                    })}
                  >
                    {meta.error || meta.submitError}
                  </p>
                )}
                {!!hint && <p className={'help'}>{hint}</p>}
                <div
                  style={{
                    width: '100%',
                    height: 400,
                    position: 'relative',
                    marginTop: 7,
                  }}
                >
                  <Map
                    google={google}
                    style={{ width: '100%', height: '100%' }}
                    initialCenter={initialCenter}
                    streetViewControl={false}
                    mapTypeControl={false}
                    center={center}
                    zoom={17}
                    onClick={(t, map, coord, x) => {
                      const { latLng } = coord
                      const lat = latLng.lat()
                      const lng = latLng.lng()
                      applyCoords(lat, lng)
                    }}
                  >
                    {!!values[addressName] && (
                      <Marker
                        name={values[addressName]}
                        position={{
                          lat: values[latName],
                          lng: values[lngName],
                        }}
                        icon={{
                          anchor: new google.maps.Point(13, 43),
                          scaledSize: new google.maps.Size(27, 43),
                          url:
                            'data:image/png;base64,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',
                        }}
                      />
                    )}
                  </Map>
                </div>
              </div>
            </div>
          )
        }}
      </Field>
    </div>
  )
}

export default GoogleApiWrapper({
  apiKey: process.env.REACT_APP_GOOGLE_API_KEY,
  LoadingContainer: () => <div className="loader" />,
})(geolocated()(LocationInput))
